import { render, staticRenderFns } from "./SmartMetricList.vue?vue&type=template&id=620513c6&scoped=true&"
import script from "./SmartMetricList.vue?vue&type=script&lang=js&"
export * from "./SmartMetricList.vue?vue&type=script&lang=js&"
import style0 from "./SmartMetricList.vue?vue&type=style&index=0&id=620513c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620513c6",
  null
  
)

export default component.exports